/* eslint-disable */
import moment from 'moment';
import Cookies from 'js-cookie';
import Config from '@/conf/Config';

export default class Logger {

  static log(message, info, level) {
    const corpParam = JSON.parse(localStorage.getItem("corpParam"));
    const logParam = corpParam && CARSHARE_CORP_ID ? `carshareCorpId:${CARSHARE_CORP_ID}` : `domain:${window.location.origin}`
    document.cookie = logParam;

    const cookie = Cookies.get();
    const logInfo = `${moment().format()} ${message} uid@${cookie.uid} ${logParam}`;
    if (window.location.host !== Config.LOCAL_HOST) {
      // datadog廃止
      // DD_LOGS.logger.info(logInfo, info, level);
      if (info && info.err) {
        // datadog廃止
        // DD_LOGS.logger.info(info.err, info, level);
      }
    } else {
      console.log(logInfo);
      if (info && info.err) {
        console.error(info.err);
      }
    }
  }

  static info(message, info) {
    this.log(message, info, 'info');
  }

  static error(message, info) {
    this.log(message, info, 'error');
  }
}
